import { AssetTypes } from 'libs.localization.common';
export const getSignInStudyNameAsset = (study) => {
    let assetType;
    if (study.isNoPIIEnabled) {
        assetType = AssetTypes.SIGN_IN_STUDY_NAME_PII;
    }
    else if (!study.isNoPIIEnabled && study.hasMixedPIISupport) {
        assetType = AssetTypes.SIGN_IN_STUDY_NAME_MIX_PII;
    }
    else {
        assetType = AssetTypes.SIGN_IN_STUDY_NAME;
    }
    return {
        type: assetType,
        id: study.id,
        version: '1',
        messages: [
            {
                namespace: 'study_name',
                messages: { value: study.displayName || study.name },
            },
        ],
        preview: {
            engine: 'react',
            id: assetType,
            default_viewport: 'mobile',
            default_product_version: study.productTemplate,
            info: {
                display_name: 'Study Name',
                list: [],
            },
        },
    };
};
